<template>
  <div v-if="loading" class="loader menu dinline-block vtop fs14 pl35" >
    <div class="loader-inner ball-pulse">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else class="menu dinline-block vtop fs14 pl35">
    <div class="localdiv tright pr15 tc6 pt35 pb15">
      <span class="fs24 fl tc3 lborder prelative pl25 lh10">{{menu[pid]['children'][id]['name']}}</span>
      <div class="pt10">
        当前位置:
        <span>学校首页 > </span>
        <span>{{menu[pid]['name']}} > </span>
        <span>{{menu[pid]['children'][id]['name']}}</span>
      </div>
    </div>
    <div class="cont tleft pt50" v-if="info.title">
      <div class="ncont tc6 fs16 lh20" v-html="info.content">
      </div>
      <div class="ncont tc6 fs16 lh20" v-if="divshwo">
        <div v-for="(item,index) in divshwo">
          <iframe :src="item"  frameborder="0"  width="690" height="500">
          </iframe>
        </div>
      </div>
    </div>
    <div v-else>
      {{msg}}
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  data(){
    return {
      id:'',
      pid:'',
      menu:{
      },
      perPage:1,
      page:1,
      info:{},
      msg:'加载中……',
      divshwo:[],
      loading:false
    }
  },
  created() {
    this.updateData();
  },
  methods:{
    updateData(){
      this.id = this.$route.query.id
      this.pid = this.$route.query.pid
      this.getData();
    },
    getData(){
      this.loading = true
      this.divshwo = [];
      var getParam = {}
      this.$request.get('get-columns', [], response => {
          if (response.status == 200) {
            this.menu = response.data;
            var id = this.menu[this.pid]['children'][this.id]['params']['id']
            getParam['id'] = id
            this.loading = false
          } else {
            console.error("获取数据失败");
          }
      this.$request.get('article/detail',getParam,response => {
        if(response.status == 200){
          if(response.data.code != 200){
            this.msg = response.data.message;
            this.info = {};
          }else{
            let res = response.data.data
            this.info = res
          }
        }else{
          this.msg = '请求失败';
        }
        this.info.article_file = this.info.article_file?this.info.article_file:[];
        for(let i = 0; i<this.info.article_file.length;i++){
          if (/\.(flv|rvmb|mp4|avi|wmv|m4v)$/gi.test(this.info.article_file[i]) ) {
            this.divshwo.push(this.info.article_file[i]);
          }
        }
      },error => {
        console.log(error)
      })
        },
        (error) => {
          console.error("请求发生错误:", error);
        });
    },
  },
  watch:{
    $route:{
      deep:true,
      handler:function($n,$o){
        this.id = $n.query.id
        this.pid = $n.query.pid
        this.info = {};
        this.getData()
      }
    }
  },
}
</script>

<style scoped>
.ncont{padding: 10px 35px;line-height: 2.2; text-align: center}

</style>



// WEBPACK FOOTER //
// src/pages/evn/Content.vue